import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface GoogleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const GoogleIcon = ({ className, ...props }: GoogleIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.5224 12.2878C23.5224 11.4774 23.444 10.6408 23.3133 9.85651H11.9932V14.4839H18.4768C18.2153 15.974 17.3526 17.2812 16.0716 18.1178L19.9408 21.1243C22.2153 19.0067 23.5224 15.9217 23.5224 12.2878Z"
      fill="#4280EF"
    />
    <path
      d="M11.9932 24C15.235 24 17.9539 22.9281 19.9408 21.0981L16.0716 18.1177C14.9997 18.8498 13.6141 19.268 11.9932 19.268C8.85603 19.268 6.21556 17.1504 5.24826 14.327L1.27448 17.3857C3.31365 21.4379 7.44429 24 11.9932 24Z"
      fill="#34A353"
    />
    <path
      d="M5.24826 14.3008C4.75154 12.8106 4.75154 11.1898 5.24826 9.69959L1.27449 6.61469C-0.424828 10.0133 -0.424828 14.0132 1.27449 17.3857L5.24826 14.3008Z"
      fill="#F6B704"
    />
    <path
      d="M11.9932 4.75854C13.6925 4.73239 15.3657 5.38597 16.5944 6.56242L20.0192 3.11151C17.8493 1.07233 14.9736 -0.025687 11.9932 0.000456276C7.44429 0.000456276 3.31365 2.5625 1.27448 6.61471L5.24826 9.69962C6.21556 6.85 8.85603 4.75854 11.9932 4.75854Z"
      fill="#E54335"
    />
  </svg>
);

export default GoogleIcon;
